export const hero = {
  bgHero: `${process.env.REACT_APP_CLOUDINARY_IMAGE_URL}/v1666364008/React-Ecommerce-Product-ImageList/hero.jpg`,
  leftHero: `${process.env.REACT_APP_CLOUDINARY_IMAGE_URL}/v1666363433/React-Ecommerce-Product-ImageList/left-hero.jpg`,
};
